import Vue from 'vue'
import { useLocalStore } from '@/store/local';

Vue.filter('dateTime', (val) => {
    if (!val) return "-";
    const localStore = useLocalStore()
    return localStore.getDateTime(val)
})

Vue.filter('date', (val) => {
    if (!val) return "-";
    const localStore = useLocalStore()
    return localStore.getDate(val)
})
